import { createContext, useContext } from "react";

export type SectionOffsetSubscriber = (sectionOffset: number) => void;

interface DetailSectionHeader {
  detailSectionHeaderElement: HTMLDivElement | null;
  detailsSectionRootContainerElement: HTMLDivElement | null;
  subscribeToSectionOffset: (callback: SectionOffsetSubscriber) => VoidFunction;
}

export const DetailSectionHeaderContext =
  createContext<DetailSectionHeader | null>(null);

export const useDetailSectionHeader = (): DetailSectionHeader => {
  const context = useContext(DetailSectionHeaderContext);
  if (!context) {
    throw new Error(
      "useDetailSectionHeader must be used within DetailSectionComponent",
    );
  }

  return context;
};
